<template>
    <div class="template-table tender-document--more-rule-tables">
        <el-tabs v-model="activeTab" @tab-click="handleTabClick">
            <el-tab-pane
                v-for="tab in tabs"
                :key="tab.ruleCode"
                :label="tab.ruleName"
                :name="tab.ruleCode"
            >
                <vbt-table isBigData v-loading="loading" class="tb-edit" element-loading-spinner="el-icon-loading" element-loading-text="列表加载中" ref="topicTable"
                    :data="tab.tableData" height="550" :row-class-name="tableRowClassName" style="width: 100%;" border highlight-current-row @expand-change="expandRow"
                    @current-change="handleCurrentChange" @row-dblclick.self="dblClick($event)" @row-click="handClick" :data-size="tab.tableData.length">
                    <vbt-table-column :label="'序号'" prop="rowNumber"  width="50" align="center"></vbt-table-column>
                    <vbt-table-column width="40">
                        <template slot="header" slot-scope="scope">
                            <el-checkbox @change="selectAll(scope,$event)" v-model="tab.selectAllType"></el-checkbox>
                        </template>
                        <template slot-scope="scope">
                            <el-checkbox v-if="!scope.row.quoteCodeParent" @change="selectOne(scope.row,$event)" v-model="scope.row.isSelect"></el-checkbox>
                            <el-checkbox v-else @change="selectTwo(scope.row,$event)" v-model="scope.row.isSelect"></el-checkbox>
                        </template>
                    </vbt-table-column>
                    <!-- -----自定义列---- -->
                    <template v-if="tab.customList && tab.customList.length !== 0">
                        <template v-for="(item, index) in tab.customList">
                            <vbt-table-column :key="item.prop + item.fieldName + index" :label="item.fieldName" width="120">
                                <template slot-scope="scope">
                                    <template v-if="index === 0 && !scope.row.quoteCodeParent">
                                        <span class="caret" @click.stop="showDetail(scope.row)" :key="item.prop">
                                            <i class="el-icon-caret-right" v-if="!scope.row.showSubTable"></i>
                                            <i class="el-icon-caret-bottom" v-if="scope.row.showSubTable"></i>
                                        </span>
                                    </template>
                                    <template v-if="item.fieldName === '老供应商编码'">
                                        <postInput class="post-input" v-if="scope.row.edit" :params="formerSupplierData"
                                            @getAdvanceValue="getformerSupplier($event,scope.row)" :mValue="scope.row.formerSupplierCode"></postInput>
                                        <span v-else>{{ scope.row.formerSupplierCode }}</span>
                                    </template>
                                    <template v-if="item.fieldName !== '老供应商编码'">
                                        <el-input v-if="scope.row.edit" v-model="scope.row[item.prop]"></el-input>
                                        <span v-else>{{ scope.row[item.prop] }}</span>
                                    </template>
                                </template>
                            </vbt-table-column>
                        </template>
                    </template>
                </vbt-table>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import postInput from '@/components/lots/otpAdvance';
import { getBidQuoteTempHeader, getBidQuoteTempData, modifyList, delTemList } from '../../../../api/bidScheme.js';

export default {
    name: 'MoreRuleTables',
    components: { postInput },
    props: {
        bidData: {
            type: Object,
            default() {
                return {};
            }
        },
        formerSupplierData: {
            type: Object,
            default() {
                return {};
            }
        },
        isPrivilege: {
            type: Boolean,
            default() {
                return false;
            }
        },
        changeSeq: {
            type: String,
            default() {
                return '';
            }
        },
        changeReson: {
            type: String,
            default() {
                return '';
            }
        }
    },
    data() {
        return {
            loading: false,
            tabs: [
                // { ruleCode: 'xxxxx', ruleName: 'xxxxx', customList: [], tableData: [], parentData: [], selectAllType: false }
            ],
            activeTab: null,
            // tableData: [[], []],
            table: [],
            currentRow: null, // 高亮的行
            dbCheckId: '' // 标记行被点击的id
            // selectAllType: false,
            // customList: [],
        };
    },
    computed: {
        activeTabIndex() {
            return this.tabs.findIndex(item => item.ruleCode === this.activeTab);
        }
    },
    methods: {
        async getData(init = false) {
            if (init) {
                await this.initTabs();
            }
            this.loading = true;
            // 获取非多规则模板表格数据
            const res = await getBidQuoteTempData({ bidNo: this.$route.query.bidNo, ruleCode: this.activeTab });
            this.loading = false;
            if (res && +res.code === 0) {
                const tab = this.tabs[this.activeTabIndex];
                const current = res.data.find(item => item.ruleCode === tab.ruleCode);
                // 如果接口没返回对应数据就置空
                tab.tableData = current ? current.data : [];
                tab.parentData = tab.tableData.filter(item => { return !item.quoteCodeParent; });
                let rowNumber = 0;
                tab.tableData.forEach(item => {
                    rowNumber++;
                    item.rowNumber = rowNumber;
                    this.$set(item, 'edit', false);
                    this.$set(item, 'showSubTable', false);
                    this.$set(item, 'isSelect', false);
                    if (item.childList) {
                        item.childList.forEach(it => {
                            rowNumber++;
                            it.rowNumber = rowNumber;
                            this.$set(it, 'edit', false);
                            this.$set(it, 'isSelect', false);
                        });
                    }
                });
            }
        },
        initTabs() {
            return getBidQuoteTempHeader({ bidNo: this.$route.query.bidNo }).then(res => {
                if (res && +res.code === 0 && res.data) {
                    this.tabs = res.data.map(item => {
                        return {
                            ruleCode: item.ruleCode,
                            ruleName: item.ruleName,
                            tableData: [],
                            parentData: [], // 父级数据
                            customList: item.childList // 获取自定义列字段
                        };
                    });
                    this.activeTab = this.tabs.length ? this.tabs[0].ruleCode : null;
                    // // 获取自定义列字段
                    // this.customList = tempInfo.data.childList;
                    // this.templateForm.templateName = tempInfo.data.templateName;
                    // this.templateForm.templateCode = tempInfo.data.templateCode;
                    // this.templateForm.templateDesc = tempInfo.data.templateDesc;
                    // this.getFile();
                    // this.isMoreRule = tempInfo.data.isMoreRule;
                }
            });
        },
        handleTabClick(tab) {
            // 当模板页签无数据时再请求数据
            if (!this.tabs[this.activeTabIndex].tableData.length) {
                this.getData(false);
            }
        },
        tableRowClassName({ row, rowIndex }) { // 表单颜色
            var reg = RegExp(/new/);
            if (reg.test(row.id)) {
                return 'warning-row';
            }
            if (this.bidData.ralationQuote === 'Y' && !row.relationLevel && row.quoteCodeParent) {
                return 'price-row';
            }
        },
        expandRow(row) { row.isCheck = true; },
        handleCurrentChange(val) { // 获取高亮的行
            this.currentRow = val;
        },
        dblClick(item, e) { // 双击表格
            item.edit = true;
            this.dbCheckId = item.id;
        },
        handClick(item) { // 单击表格
            var reg = RegExp(/new/);
            item.isCheck = true;// 只要被点击过的行就算被修改过
            item.bidType = this.bidData.bidType;
            this.tabs[this.activeTabIndex].tableData.forEach(item => {
                item.edit = false;
            });
            if (item.id === this.dbCheckId || reg.test(item.id)) {
                item.edit = true;
            }
            this.dbCheckId = item.id;
        },
        selectAll(row, val) {
            this.tabs[this.activeTabIndex].tableData.forEach(item1 => {
                item1.isSelect = val;
                if (item1.childList) {
                    item1.childList.forEach(item2 => {
                        item2.isSelect = val;
                    });
                }
            });
            this.tabs[this.activeTabIndex].selectAllType = val;
        },
        selectOne(row, val) { // 父节点勾选框;
            row.edit = false;
            row.isSelect = val;
            if (row.childList) {
                row.childList.forEach(item => {
                    item.isSelect = val;
                });
            }
            this.commonAll();
        },
        selectTwo(row, val) { // 子节点勾选框
            row.edit = false;
            row.isSelect = val;
            this.commonParent(row);
            this.commonAll();
        },
        // 判断表格数据是否已全选
        commonAll() {
            const { parentData } = this.tabs[this.activeTabIndex];
            let count = 0;
            for (let i = 0; i < parentData.length; i++) {
                if (parentData[i].isSelect) { count++; }
            }
            if (count === parentData.length) {
                this.tabs[this.activeTabIndex].selectAllType = true;
            } else { this.tabs[this.activeTabIndex].selectAllType = false; }
        },
        commonParent(row) { // 子节点勾选时，判断父节点
            const { parentData } = this.tabs[this.activeTabIndex];
            const table = parentData.filter(item => { return row.quoteCodeParent === item.quoteCode; });
            let count = 0;
            table[0].childList.forEach(item => {
                if (item.isSelect) { count++; }
            });
            if (count === table[0].childList.length) {
                table[0].isSelect = true;
            } else { table[0].isSelect = false; }
        },
        showDetail(row) {
            row.isCheck = true;
            row.showSubTable = !row.showSubTable;
            const index = this.tabs[this.activeTabIndex].tableData.indexOf(row);
            if (row.showSubTable) { // 展开
                this.tabs[this.activeTabIndex].tableData.splice(index + 1, 0, ...row.childList);
            } else { // 缩回
                this.tabs[this.activeTabIndex].tableData.splice(index + 1, row.childList.length);
            }
        },
        getformerSupplier(val, row) {
            row.formerSupplierName = val.supplierNameCn;
            row.formerSupplierCode = val.supplierCode;
        },
        async saveList() { // 保存
            let saveArr = [];
            let valid = true;
            this.tabs.forEach((tab, tabIndex) => {
                // 校验不通过直接跳出
                if (!valid) { return false; }
                for (let i = 0; i < tab.parentData.length; i++) { // 预计业务量校验
                    if (tab.parentData[i].expectTraffic * 1 <= 0 || tab.parentData[i].expectTraffic === null) {
                        this.$message.warning(`${tab.ruleName} 第${tab.parentData[i].rowNumber}行预计业务量不能小于0`);// 父节点预计业务量小于0
                        valid = false;
                        break;
                    } else if (tab.parentData[i].childList) {
                        const expectTrafficRes = this.expectTrafficDecide(i, tabIndex);
                        if (expectTrafficRes === false) {
                            valid = false;
                            break;
                        }
                    }
                }

                if (valid && this.bidData.ralationQuote === 'Y') { // 关联排序号不能等于排序号
                    for (let i = 0; i < tab.parentData.length; i++) {
                        if (tab.parentData[i].bidLevel * 1 <= tab.parentData[i].relationLevel * 1) {
                            this.$message.warning(`${tab.ruleName} 第${tab.parentData[i].rowNumber}行关联排序号不能大于或等于排序号`);// 父节点关联排序号不能等于排序号
                            valid = false;
                            break;
                        } else if (tab.parentData[i].childList) {
                            const relationRes = this.relationDecide(i, tabIndex);
                            if (relationRes === false) {
                                valid = false;
                                break;
                            }
                        }
                    }
                }

                if (valid && this.bidData.blockPriceControl === 'Y') { // 拦标价高不能低于拦标价低
                    for (let i = 0; i < tab.parentData.length; i++) {
                        if (tab.parentData[i].quoteRangeMin * 1 > tab.parentData[i].quoteRangeMax * 1) { // 父节点拦标价高不能低于拦标价低
                            this.$message.warning(`${tab.ruleName} 第${tab.parentData[i].rowNumber}行拦标价高不能低于拦标价低`);
                            valid = false;
                            break;
                        } else if (tab.parentData[i].childList) {
                            for (let k = 0; k < tab.parentData[i].childList.length; k++) { // 子节点拦标价高不能低于拦标价低
                                if (tab.parentData[i].childList[k].quoteRangeMin * 1 > tab.parentData[i].childList[k].quoteRangeMax * 1) {
                                    this.$message.warning(`${tab.ruleName} 第${tab.parentData[i].childList[k].rowNumber}行拦标价高不能低于拦标价低`);
                                    valid = false;
                                    break;
                                }
                            }
                        }
                    }
                }
                const arr = [];
                var reg = RegExp(/new/);
                tab.parentData.forEach((item, index) => {
                    if (item.isCheck) {
                        // 使用深拷贝数据作提交处理，避免污染渲染的数据
                        arr.push(JSON.parse(JSON.stringify(item)));
                    }
                });
                arr.forEach(item => {
                    if (reg.test(item.id)) {
                        delete item.id;
                    }
                    if (item.childList) {
                        item.childList.forEach((it, index) => {
                            if (reg.test(it.id)) {
                                delete it.id;
                            }
                            if (it.quoteRangeMax === '*' || it.quoteRangeMin === '*') {
                                it.quoteRangeMax = null;
                                it.quoteRangeMin = null;
                            }
                        });
                        var newChildList = item.childList.filter(function (item) {
                            return item.isCheck;
                        });
                        item.templatesList = newChildList;
                        delete item.childList;
                    }
                });
                saveArr = saveArr.concat(arr);
            });

            // 校验不通过直接跳出
            if (!valid) { return false; }

            let url = '';// 判断是否特权修改，是的话加上特定参数
            if (this.isPrivilege) { url = `?specialChange=Y&changeSeq=${this.changeSeq}&changeReson=${this.changeReson}`; }// 判断是否特权修改，是的话加上特定参数
            const res = await modifyList(url, saveArr);
            if (res && +res.code === 0) {
                this.clearSavedTabsData(saveArr);
                this.getData(false);
                this.$message.success('操作成功');
                this.$emit('saveSuccess');
            }
        },
        // 清空保存过模板数据的模板页签，以便可以下次再点击模板页签时刷新数据
        clearSavedTabsData(saveArr) {
            const ruleCodes = new Set(saveArr.map(item => item.ruleCode));
            ruleCodes.forEach(ruleCode => {
                const index = this.tabs.findIndex(tab => tab.ruleCode === ruleCode);
                this.tabs[index].tableData = [];
                this.tabs[index].parentData = [];
            });
        },
        async deleteTemplate() { // 删除
            const delList = [];
            const tableBel = this.tabs[this.activeTabIndex].tableData.filter(item => { return !item.quoteCodeParent; });
            tableBel.forEach(item => {
                if (item.isSelect) { delList.push(item); } else {
                    if (item.childList) {
                        item.childList.forEach(item2 => {
                            if (item2.isSelect) {
                                delList.push(item2);
                            }
                        });
                    }
                }
            });
            var reg = RegExp(/new/);
            const arr = [];
            delList.forEach(item => {
                if (reg.test(item.id) === false) {
                    const obj = { id: item.id, quoteCode: item.quoteCode, quoteCodeParent: item.quoteCodeParent, bidNo: this.$route.query.bidNo, ruleCode: this.activeTab };
                    arr.push(obj);
                }
            });
            if (delList.length === 0) {
                this.$message.warning('没有选中数据');
            } else {
                this.$confirm('是否确定要删除选择的数据？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    // this.loadDelete = true;
                    let url = '';// 判断是否特权修改，是的话加上特定参数
                    if (this.isPrivilege) { url = `?specialChange=Y&changeSeq=${this.changeSeq}&changeReson=${this.changeReson}`; }// 判断是否特权修改，是的话加上特定参数
                    const res = await delTemList(url, arr);
                    // this.loadDelete = false;
                    if (res && +res.code === 0) {
                        this.getData(false);
                        this.$message.success('操作成功');
                        this.$emit('deleteSuccess');
                        if (!this.currentRow || this.currentRow.quoteCodeParent === null) { // 删除父节点后，还能添加父节点
                            this.currentRow = null;
                        }
                    }
                }).catch(() => {});
            }
        },
        expectTrafficDecide(i, tabIndex) {
            const { ruleName, parentData } = this.tabs[tabIndex];
            for (let k = 0; k < parentData[i].childList.length; k++) {
                if (parentData[i].childList[k].expectTraffic * 1 <= 0 || parentData[i].childList[k].expectTraffic === null) {
                    this.$message.warning(`${ruleName} 第${parentData[i].childList[k].rowNumber}行预计业务量不能小于0`);// 子节点预计业务量小于0
                    return false;
                }
            }
        },
        relationDecide(i, tabIndex) {
            const { ruleName, parentData } = this.tabs[tabIndex];
            for (let k = 0; k < parentData[i].childList.length; k++) {
                if (parentData[i].childList[k].bidLevel * 1 <= parentData[i].childList[k].relationLevel * 1) {
                    this.$message.warning(`${ruleName} 第${parentData[i].childList[k].rowNumber}行关联排序号不能大于或等于排序号`);// 子节点关联排序号不能等于排序号
                    return false;
                }
            }
        },
        changeRuleTemp(moreRuleChildList = []) {
            this.tabs = moreRuleChildList.map(item => {
                return {
                    ruleCode: item.ruleCode,
                    ruleName: item.ruleName,
                    tableData: [],
                    parentData: [],
                    customList: item.fieldList // 获取自定义列字段
                };
            });
            this.activeTab = this.tabs.length ? this.tabs[0].ruleCode : null;
        }
    }
};
</script>